import React, { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import "./Navbar.css";

const modules = [
  { path: "/modulo-1", label: "01 Seguridad" },
  { path: "/modulo-2", label: "02 Runtime" },
  { path: "/modulo-3", label: "03 RAG" },
  { path: "/modulo-4", label: "04 MCP Gateway" },
  { path: "/modulo-5", label: "05 Memoria" },
  { path: "/modulo-6", label: "06 Bonus" },
];

function Navbar() {
  const location = useLocation();
  const [isOpen, setIsOpen] = useState(false);

  return (
    <motion.nav
      className="navbar"
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      transition={{ duration: 0.5 }}
    >
      <div className="navbar-content">
        <Link to="/" className="navbar-brand">
          <span className="brand-nequi">Nequi</span>
          <span className="brand-separator">x</span>
          <span className="brand-aws">AWS</span>
          <span className="brand-separator">x</span>
          <img
            src={process.env.PUBLIC_URL + "/pragma-logo.png"}
            alt="PRAGMA"
            className="brand-pragma"
          />
        </Link>

        <button className="navbar-toggle" onClick={() => setIsOpen(!isOpen)}>
          <span></span>
          <span></span>
          <span></span>
        </button>

        <div className={`navbar-links ${isOpen ? "open" : ""}`}>
          {modules.map((mod) => (
            <Link
              key={mod.path}
              to={mod.path}
              className={`nav-link ${location.pathname === mod.path ? "active" : ""}`}
              onClick={() => setIsOpen(false)}
            >
              {mod.label}
            </Link>
          ))}
        </div>
      </div>
    </motion.nav>
  );
}

export default Navbar;
